export const instanceReportQueryKeys = {
  all: ['instance_report'],
  details: () => [...instanceReportQueryKeys.all, 'detail'],
  detail: (id) => [...instanceReportQueryKeys.details(), id],
  pagination: (page, filters = {}) => {
    // Create a consistent, serializable representation of filters
    const filterKey = Object.entries(filters)
      .filter(([, value]) => value !== undefined && value !== '')
      .map(([key, value]) => `${key}:${value}`)
      .sort()
      .join('|');

    return [
      ...instanceReportQueryKeys.all,
      'pagination',
      page.toString(),
      filterKey,
    ];
  },
  infinite: () => [...instanceReportQueryKeys.all, 'infinite'],
};
